module.exports = __webpack_public_path__ + "static/media/Resume-Coelho,Benson.faa579d2.pdf";